import { Component } from "@angular/core"
import { trigger, transition, animate, style } from "@angular/animations"
import { AppService } from '../../../../app.service';
import { MatDialog } from '@angular/material/dialog';import { ImplementStatusModalComponent } from '../../implement-status-modal/implement-status-modal.component';
import { AttachImplementModalComponent } from '../../attach-implement-modal/attach-implement-modal.component';
import { RecordRepairModalComponent } from '../../record-repair-modal/record-repair-modal.component';
import { RecordReplaceModalComponent } from '../../record-replace-modal/record-replace-modal.component';
import { ChangeImplementJobsiteModalComponent } from '../../change-implement-jobsite-modal/change-implement-jobsite-modal.component';
import { ImplementDetails, EquipmentDetails, InspectionDetails, ComponentDetails, ImplementHistory } from './implement-rebuild';
import { ImplementRebuildService } from './implement-rebuild.service';
import { ActivatedRoute, Router } from '@angular/router';
import { OrdinalDateParse } from '../../adapters/ordinal-date-adapter';
import { SchematicViewComponent } from '../../schematic-view/schematic-view.component';
import { SetupImplementService } from "../../setup-implement/setup-implement.service";
import { GenericIdName } from "../../setup-implement/setup-implement.model";
import { EquipmentDetailsParams } from "../../setup-equipment/setup-equipment.model";
import { DomSanitizer } from "@angular/platform-browser";
import { ImplementForEquipmentDetails } from "../../equipment-details/equipment-details.model";
import { GETUpdateMeterComponent } from "../../equipment-details/components/update-meter/get-update-meter.component";
import { GETChangeJobsiteComponent } from "../../equipment-details/components/change-jobsite/change-jobsite.component";
import { ImplementActionComponent } from "../../equipment-details/components/implement-action/implement-action.component";
import { AppUris } from "../../entities/app-config/model";
import { PerformInspectionComponent } from "../../equipment-details/components/perform-inspection/perform-inspection.component";
import { ImplementRebuildDialogComponent } from "../../equipment-details/components/implement-rebuild-dialog/implement-rebuild-dialog.component";
import { ImplementRebuildCompleteDialogComponent } from "../../equipment-details/components/implement-rebuild-complete-dialog/implement-rebuild-complete-dialog.component";
import { ImplementTargetsUpdateComponent } from "../../equipment-details/components/implement-targets-update/implement-targets-update.component";
import { FECRInspectionHistoryVM } from "../FECRDashboard/fecr-search-panel/fecr-search-panel.model";
import { MoveImplementToRepairerComponent } from "../move-implement-to-repairer/move-implement-to-repairer.component";
import { FecrProjectContactDialogComponent } from "../fecr-project-contact-dialog/fecr-project-contact-dialog.component";
import { FecrPartsListComponent } from "../fecr-parts-list/fecr-parts-list.component";
import { UserService } from "../../../../shared/services/user.service";
import { PreferencesService } from "../../../../modules/preferences/preferences.service";
import { EnablePreferenceTasksVM } from "../../../../modules/preferences/models/preferences.model";


@Component({
  selector: 'app-fecr-implement-rebuild-details',
  templateUrl: './fecr-implement-rebuild-details.component.html',
  styleUrls: ['./fecr-implement-rebuild-details.component.scss'],
  animations: [
    trigger(
      'enterAnimation', [
      transition(':enter', [
        style({ transform: 'translateY(25%)', opacity: 0 }),
        animate('500ms', style({ transform: 'translateY(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        style({ transform: 'translateY(0)', opacity: 1 }),
        animate('500ms', style({ transform: 'translateY(100%)', opacity: 0 }))
      ])
    ]
    )]
})


export class GETFecrImplementRebuildDetailsComponent{
  //@ViewChild('btnStatusChange') statusChange: ElementRef;

  //pageTitle: string;// = "BKT0001 Details (Excavator Bucket)";
  //pageSubTitle: string = "Record and view data about this implement here. "; // Will need to make this dynamic

  implement: ImplementDetails = new ImplementDetails();
  equipment: EquipmentDetails = new EquipmentDetails();
  inspections: InspectionDetails[] = [];
  getComponents: ComponentDetails[] = [];
  implementHistory: ImplementHistory[] = [];

  // Toggles to show or hide different components.
  showImplement: boolean = false;
  showEquipment: boolean = false;
  showInspections: boolean = false;
  showComponents: boolean = false;
  showHistory: boolean = false;
  showChangeJobsiteModal: boolean = false;
  showRemoveImplementModal: boolean = false;
  showAttachImplementModal: boolean = false;
  showImplementStatusModal: boolean = false;
  showRepairOrReplaceModal: boolean = false;

  implementId: number;

  implementStatusText: string = "";
  implementStatusDesc: string = "";

  currency_symbol: string = "$";
  unit_life: string = "hrs";

  // Define eval colour thresholds.
  THRESHOLD_EVAL_A: number = 30;
  THRESHOLD_EVAL_B_MAX: number = 60;
  THRESHOLD_EVAL_B_MIN: number = 30;
  THRESHOLD_EVAL_C_MAX: number = 80;
  THRESHOLD_EVAL_C_MIN: number = 60;

  dateParser: OrdinalDateParse = new OrdinalDateParse();

  GETUri: string = "";

  wearStyleId: number;
  makeList: GenericIdName[] = [];
  loading: boolean = false
  equipmentDetails: EquipmentDetailsParams;
  CustomerId: number;
  inspectionDetails: FECRInspectionHistoryVM[];
  ImplementForEquipmentDetails: ImplementForEquipmentDetails[] = [];
  appUris: AppUris;
  isJobRoleDefault: boolean = true;
  constructor(private route: ActivatedRoute, private _appService: AppService, public changeStatusModal: MatDialog,
    public attachImplementModal: MatDialog, public removeImplementModal: MatDialog,
    private _moduleService: ImplementRebuildService, public recordRepairModal: MatDialog, public recordReplaceModal: MatDialog,
    public changeImplementJobsiteModal: MatDialog, public schematicViewComponent: MatDialog,
    private _implementService: SetupImplementService,   private _user: UserService, private _router: Router,
    private _sanitizer: DomSanitizer,
    private readonly _pref: PreferencesService,
 ) { }

  ngOnInit() {

    this._appService.setPageTitle('Implement Rebuild Details');
    //this._appService.setPageSubTitle('');



    // this._appService.returnBrandedGETHost().subscribe(result => {
    //     this.GETUri = result;
    // });

    this.route.params.subscribe(params => {
      this.implementId = +params['implementId'];

      if (this.implementId) {
        this.initialise();
      }
    });
    this._appService.getAppUris().subscribe(result => { this.appUris = result; });
    this.GetPreferenceTaskList();
  }

  initialise() {
    this.LoadJobRoles();
    this.loadEquipmentDetails();
    this.loadMakes();
    this.loadImplementDetails();
    this.LoadFECRInspectionHistory();
    this.reloadDetails();

  }

  LoadFECRInspectionHistory(){
    this._moduleService.GetFECRInspectionHistory(this.implementId).subscribe(res=>{
      console.log("History", res)
      this.inspectionDetails = res;
    })
  }

  LoadJobRoles() {
    this._user.getUserJobRoles().subscribe(roles => {
      roles.forEach(r => {
        switch (r.Name) {
          case 'Inspectors':
            this.isJobRoleDefault = false;
            break;
          case 'Interpreters':
            this.isJobRoleDefault = false;
            break;
          case 'Super User':
            this.isJobRoleDefault = false;
            break;
          case 'Administrator':
            this.isJobRoleDefault = false;
            break;
            case 'Customer Admin':
              this.isJobRoleDefault = false;
              break;
        }
      });

    })
  }

  // Implement Makes
  loadMakes() {
    this._implementService.GetImplementMakes().subscribe(r => {
      this.makeList = r;
    });
  }

  loadEquipmentDetails() {
    this._moduleService.returnEquipmentForGET(this.implementId.toString()).subscribe(equipment => {
      this.equipmentDetails = equipment;

      //this.loadObservationPointsForImplement();
      this.CustomerId = this.equipmentDetails.CustomerId;
      console.log(this.equipmentDetails)

      
    });

  }

isInventory:boolean=false;
isInRepairer :boolean=false;
Repairer:string;
WorkShop:string;
InventoryCustomerId:number
InventoryJobsiteId:number
    
  loadImplementDetails() {

    this.loading = true;
    this._moduleService.GetSchematicsForImplement(this.implementId).subscribe(details => {
      this.ImplementForEquipmentDetails = details;
      this.isInRepairer = this.ImplementForEquipmentDetails[0].ImplementSummary.IsInRepairer;
      this.isInventory = this.ImplementForEquipmentDetails[0].ImplementSummary.IsInventory;
      this.Repairer = this.ImplementForEquipmentDetails[0].ImplementSummary.ReapirerName;
      this.WorkShop = this.ImplementForEquipmentDetails[0].ImplementSummary.WorkShop;
      this.InventoryCustomerId = this.ImplementForEquipmentDetails[0].ImplementSummary.InventoryCustomerId;
      this.InventoryJobsiteId = this.ImplementForEquipmentDetails[0].ImplementSummary.InventoryJobsiteId;


      this.loading = false
    });

  }
 
  
  getImage(image: string) {
    return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
  }
  getEvalClass(wornPct: number) {
    if (wornPct <= 30) {
      return " WornPctCell evalColorA";
    }
    else if ((wornPct > 30) && (wornPct <= 60)) {
      return " WornPctCell evalColorB";
    }
    else if ((wornPct > 60) && (wornPct <= 80)) {
      return " WornPctCell evalColorC";
    }
    else if (wornPct > 80) {
      return "WornPctCell evalColorX";
    }
    return " WornPctCell noEval";
  }

  getEvalCode(evalcode: string) {
    if (evalcode == 'A') {
      // return "evalColorACode";
      return " WornPctCell evalColorA";
    }
    else if (evalcode == 'B') {
      //return "evalColorBCode";
      return " WornPctCell evalColorB";
    }
    else if (evalcode == 'C') {
      //return "evalColorCCode";
      return " WornPctCell evalColorC";
    }
    else if (evalcode == 'X') {
      //return "evalColorXCode";
      return "WornPctCell evalColorX";
    }
    return " noEvalCode";
  }



  //open move to invetory
  openMovetoRepairer() {
    let openRemoveImplementModalRef = this.removeImplementModal.open(MoveImplementToRepairerComponent, {
      width: '550px',
      data: {
        isReturn:false,
        implementId: this.implementId,
        jobsiteId: this.equipmentDetails.JobsiteId,
        jobsiteName: this.equipmentDetails.JobsiteName,
        equipmentId: this.equipmentDetails.equipmentId,
        equipmentSMU: this.equipmentDetails.Smu,
      }
    });
    openRemoveImplementModalRef.afterClosed().subscribe(() => {
      this.initialise();
    });
  }

  openReturnToInventoryFromRepairer(){
    let openRemoveImplementModalRef = this.removeImplementModal.open(MoveImplementToRepairerComponent, {
      width: '550px',
      data: {
        isReturn:true,
        implementId: this.implementId,
        InventoryCustomerId:this.InventoryCustomerId,
        InventoryJobsiteId:this.InventoryJobsiteId,
      }
    });
    openRemoveImplementModalRef.afterClosed().subscribe(() => {
      this.initialise();
    });
  }


  //open Perfom Inspection
  openPerformInspectionModal() {
    let openPerformInspectionModalRef = this.attachImplementModal.open(PerformInspectionComponent, {
      width: '550px',
      data: {
        implementId: this.implementId,
        CustomerId: this.equipmentDetails.CustomerId,
        CustomerName: this.equipmentDetails.CustomerName,
        jobsiteId: this.equipmentDetails.JobsiteId,
        jobsiteName: this.equipmentDetails.JobsiteName,
        implementName: this.ImplementForEquipmentDetails[0].ImplementSummary.Name
      }
    });
    openPerformInspectionModalRef.afterClosed().subscribe(() => {
      this.initialise();
    });
  }

  //open Move from inventory
  openAttachImplementModal() {
    let openAttachImplementModalRef = this.attachImplementModal.open(AttachImplementModalComponent, {
      width: '550px',
      data: {
        implementId: this.implementId,
        jobsiteId: this.equipmentDetails.JobsiteId,
        jobsiteName: this.equipmentDetails.JobsiteName,
        implementName: this.ImplementForEquipmentDetails[0].ImplementSummary.Name
      }
    });
    openAttachImplementModalRef.afterClosed().subscribe((res) => {
      if(res==true){
        window.close();
        window.open('/implementdetails/'+ this.implementId); 
      }
     
      
    });
  }

  //open Project contact list with emails and stuff
  OpenProjectContacts(){
    let openAttachImplementModalRef = this.attachImplementModal.open(FecrProjectContactDialogComponent, {
      width: '1000px',
      data: {
        implementId: this.implementId,
        
      }
    });
    openAttachImplementModalRef.afterClosed().subscribe(() => {
      this.initialise();
    });
  }

  //open project part list 
  OpenPartList(){
    let openAttachImplementModalRef = this.attachImplementModal.open(FecrPartsListComponent, {
      width: '800px',
      data: {
        implementId: this.implementId,
        implementName:this.ImplementForEquipmentDetails[0].ImplementSummary.Name,
        
      }
    });
    openAttachImplementModalRef.afterClosed().subscribe(() => {
     // this.initialise();
    });
  }


  //change status 
  openChangeStatusModal() {
    if (this.isJobRoleDefault == false) {
      if (this.showImplementStatusModal) {
        let changeStatusModalRef = this.changeStatusModal.open(ImplementStatusModalComponent, {
          width: '550px',
          data: {
            implementId: this.implementId,
            jobsiteId: this.equipmentDetails.JobsiteId,
            jobsiteName: this.equipmentDetails.JobsiteName,
          }
        });
        changeStatusModalRef.afterClosed().subscribe(() => {
          this.initialise();
        });
      }
    }



  }


  //open update meter unit dialog

  openUpdateMeter() {
    const updateMeterDialog = this.changeStatusModal.open(GETUpdateMeterComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        equipmentId: this.equipmentDetails.equipmentId,
        customerId: this.equipmentDetails.CustomerId,
        smuPrechange: this.equipmentDetails.Smu,
        lastUpdateTime: this.equipmentDetails.LastInspectionDate,
        bcmPrechange: this.equipmentDetails.Bcm,
        tonPrechange: this.equipmentDetails.Ton,
        implementId: this.implementId,

      }
    });

    const instance = updateMeterDialog.componentInstance;
    instance.changeLateUpdateTime(this.equipmentDetails.LastInspectionDate);

    updateMeterDialog.afterClosed().subscribe(newMeterReading => {
      if (newMeterReading === undefined)

        return;

      if (newMeterReading) {
        this.loadEquipmentDetails();
        this.initialise();
        // this.loadEquipmentSystems();
      }
    });
  }

  //open change jobsite equipment

  openChangeJobsite() {
    const dialogRef = this.changeStatusModal.open(GETChangeJobsiteComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        equipmentId: this.equipmentDetails.equipmentId,
        customerId: this.equipmentDetails.CustomerId
      }
    });

    dialogRef.afterClosed().subscribe(newJobsiteName => {
      if (newJobsiteName == null || newJobsiteName === undefined)
        return;
      if (newJobsiteName !== this.equipmentDetails.JobsiteName) {
        // this.equipmentDetails.JobsiteName = newJobsiteName;
        this.loadEquipmentDetails();
      }
    });
  }


  //open chnage jobsite Inventory
  openChangeJobsiteInventory() {
    const dialogRef = this.changeStatusModal.open(GETChangeJobsiteComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        implementId: this.implementId,
      }
    });

    dialogRef.afterClosed().subscribe(newJobsiteName => {
      if (newJobsiteName == null || newJobsiteName === undefined)
        return;
      if (newJobsiteName !== this.equipmentDetails.JobsiteName) {
        // this.equipmentDetails.JobsiteName = newJobsiteName;
        this.loadEquipmentDetails();
      }
    });
  }

  //open Implemtn action
  openImplementAction() {
    const dialogRef = this.changeStatusModal.open(ImplementActionComponent, {
      panelClass: 'removeModalOverflow',
      height:'600px',
      data: {
        equipmentId: this.equipmentDetails.equipmentId,
        customerId: this.equipmentDetails.CustomerId,
        jobsiteId: this.equipmentDetails.JobsiteId,
      }
    });

    dialogRef.afterClosed().subscribe(r => {
      this.initialise();
    });
  }


  //open Rebuild Implement
  openRebuildImplement() {
    const dialogRef = this.changeStatusModal.open(ImplementRebuildDialogComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        implementId: this.implementId,
        customerId: this.equipmentDetails.CustomerId,
        implementName: this.ImplementForEquipmentDetails[0].ImplementSummary.Name,
        jobsiteId: this.equipmentDetails.JobsiteId,
        jobsiteName: this.equipmentDetails.JobsiteName,
      }
    });

    dialogRef.afterClosed().subscribe(r => {
      this.initialise();
    });
  }

  //open Complete Rebuild Implement
  CompleteRebuild() {
    const dialogRef = this.changeStatusModal.open(ImplementRebuildCompleteDialogComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        implementId: this.implementId,
        customerId: this.equipmentDetails.CustomerId,
        implementName: this.ImplementForEquipmentDetails[0].ImplementSummary.Name,
        jobsiteId: this.equipmentDetails.JobsiteId,
        jobsiteName: this.equipmentDetails.JobsiteName,
      }
    });

    dialogRef.afterClosed().subscribe(r => {
      this.initialise();
    });
  }

  //open Complete Rebuild Implement
  openUpdateTargets() {
    const dialogRef = this.changeStatusModal.open(ImplementTargetsUpdateComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        implementId: this.implementId,
        customerId: this.equipmentDetails.CustomerId,
        implementName: this.ImplementForEquipmentDetails[0].ImplementSummary.Name,
        jobsiteId: this.equipmentDetails.JobsiteId,
        jobsiteName: this.equipmentDetails.JobsiteName,
      }
    });

    dialogRef.afterClosed().subscribe(r => {
      this.initialise();
    });
  }

  openRecordRepairModal(id, name) {
    let openRecordRepairModalRef = this.recordRepairModal.open(RecordRepairModalComponent, {
      width: '550px',
      data: {
        jobsiteId: this.implement.jobsiteId,
        jobsiteName: this.implement.jobsite,
        componentId: id,
        componentName: name
      }
    });
    openRecordRepairModalRef.afterClosed().subscribe(() => {
      //this.reloadDetails();
    })
  }

  openRecordReplaceModal(id, name) {
    let openRecordReplaceModalRef = this.recordReplaceModal.open(RecordReplaceModalComponent, {
      width: '550px',
      data: {
        jobsiteId: this.implement.jobsiteId,
        jobsiteName: this.implement.jobsite,
        componentId: id,
        componentName: name
      }
    });
    openRecordReplaceModalRef.afterClosed().subscribe(() => {
      // this.reloadDetails();
    })
  }

  openChangeImplementJobsiteModal() {
    let changeImplementJobsiteModalRef = this.changeImplementJobsiteModal.open(ChangeImplementJobsiteModalComponent, {
      width: '550px',
      data: { implementId: this.implementId }
    });
    changeImplementJobsiteModalRef.afterClosed().subscribe(() => {
      // this.reloadDetails();
    });
  }

  // Determine the eval colours to use.
  determineEvalColour(val) {
    if (val <= this.THRESHOLD_EVAL_A) {
      return 'eval-a';
    } else if ((val > this.THRESHOLD_EVAL_B_MIN) && (val <= this.THRESHOLD_EVAL_B_MAX)) {
      return 'eval-b';
    } else if ((val > this.THRESHOLD_EVAL_C_MIN) && (val <= this.THRESHOLD_EVAL_C_MAX)) {
      return 'eval-c';
    } else {
      return 'eval-x';
    }
  }

  getBackColour(status:string){
    if(status=="Completed"){
      return 'statusComplete';
    }
    else if(status=="In Progress"){
      return 'statusInProgress';
    }else{
      return 'statusNotStart';

    }
  }

  openInspection(inspection:FECRInspectionHistoryVM) {

    if(inspection.FormId>0){
     // window.open('/digitalform/fill/'+ inspection.FormId +'/' + inspection.FormUploadId ,'_blank'); 

     this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
      if(res=="True"){
        this._router.navigate(['/digitalform/fill', inspection.FormId,inspection.FormUploadId]);
      }else{             
        window.open('/digitalform/fill/'+ inspection.FormId +'/' + inspection.FormUploadId ,'_blank'); 
       
      }
  });

    }else if(inspection.FECRInspectionType!="Disassembly Inspection "){
     // window.open('/fecr/prepostshipment/'+ this.implementId +'/' + inspection.FormUploadId ,'_blank');
     
     this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
      if(res=="True"){
        this._router.navigate(['/fecr/prepostshipment', this.implementId, inspection.FormUploadId]);
      }else{             
        window.open('/fecr/prepostshipment/'+ this.implementId +'/' + inspection.FormUploadId ,'_blank');
       
      }
  });
    }
    
  }

  mouseOverStatus() {
   // this.statusChange.nativeElement.style.background = "#85888B";
  }

  mouseLeaveStatus() {
    //this.statusChange.nativeElement.style.background = "#1D2F36";
  }

  openSchematic(): void {
    let schematicViewModalRef = this.schematicViewComponent.open(SchematicViewComponent, {
      width: '720px',
      height: '695px',
      data: { implementId: this.implementId }
    });
    schematicViewModalRef.afterClosed().subscribe(() => {

    });
  }

  reloadDetails() {​
    this.route.params.subscribe(params => {​
      this.implementId = +params['implementId'];

      // Implement details.
      this._moduleService.returnGETById(this.implementId.toString()).subscribe(res => {​
        var result = JSON.parse(res.toString());

        if (result != null) {​
          this.implement = result;

          if (this.implement.lastInspection != "N/A") {​
            //this.implement.lastInspection = this.dateParser.formatDateOrdinal(result.lastInspection, true);
            this.implement.lastInspection = result.lastInspection;
          }​
          if (this.implement.status != "N/A") {​
            var statusDesc = "This implement is currently ";
            var repairerDesc = this.implement.repairerName;
            var workshopDesc = this.implement.workshopName;

            if (this.implement.status == "On Equipment") {​
              this.implementStatusText = this.implement.status;
              this.implementStatusDesc = statusDesc + "on an equipment. ";
              this.showChangeJobsiteModal = false;
              this.showRemoveImplementModal = true;
              this.showAttachImplementModal = false;
              this.showImplementStatusModal = false;
              this.showRepairOrReplaceModal = false;
            }​
            else {​
              this.implementStatusText = "In Inventory " + this.implement.status;
              this.implementStatusDesc = statusDesc + this.implement.status + ".";
              if ((repairerDesc != "") && (workshopDesc != "")) {​
                this.implementStatusDesc += " It has been assigned to the repairer <b>"
                  + repairerDesc + "</b> at <b>" + workshopDesc + "</b>.";
              }​

              this.showChangeJobsiteModal = true;
              this.showRemoveImplementModal = false;
              // GET-113: Equipment Awaiting Repair Validation
              var readyForUse_string = "Ready for Use";
              if (this.implement.status.toLowerCase() == readyForUse_string.toLowerCase()) {​
                this.showAttachImplementModal = true;
              }​ else {​
                this.showAttachImplementModal = false;
              }​
              this.showImplementStatusModal = true;
              this.showRepairOrReplaceModal = true;
            }​
          }​

          //this.pageTitle = this.implement.serialNo + " Details (" + this.implement.implementType + ")";
          this.showImplement = true;
        }​ else {​
          this.implement.customer = "";
          this.implement.jobsite = "";
          this.implement.make = "";
          this.implement.model = "";
          this.implement.life = 0;
          this.implement.serialNo = "";
          this.implement.implementType = "";
          this.implement.lastInspection = "";
          this.implement.status = "";

          this.showImplement = false;
        }​
        //this._appService.setPageTitle(this.pageTitle);
      }​, error => {​ console.log(error); }​);

      // Inspection Details
      this._moduleService.returnInspectionDetailsForGET(this.implementId.toString()).subscribe(res => {​
        var result = JSON.parse(res.toString());

        if (result != null) {​
          this.inspections = result;

          for (var i = 0; i < this.inspections.length; i++) {​
            this.inspections[i].inspectionDate = this.dateParser.formatDateOrdinal(this.inspections[i].inspectionDate, false);
          }​

          this.showInspections = true;
        }​ else {​
          this.showInspections = false;
        }​

      }​, error => {​ console.log(error); }​);

      // GET Component Details
      this._moduleService.returnComponentsForGET(this.implementId.toString()).subscribe(res => {​
        var result = JSON.parse(res.toString());

        if (result != null) {​
          this.getComponents = result;
          this.showComponents = true;
        }​ else {​
          this.showComponents = false;
        }​

      }​, error => {​ console.log(error); }​);

      // Implement History
      this._moduleService.returnHistoryForGET(this.implementId.toString()).subscribe(res => {​
        var result = JSON.parse(res.toString());

        if (result != null) {​
          this.implementHistory = result;

          for (var i = 0; i < this.implementHistory.length; i++) {​
            this.implementHistory[i].date = this.dateParser.formatDateOrdinal(this.implementHistory[i].date, false);
          }​

          this.showHistory = true;
        }​ else {​
          this.showHistory = false;
        }​
      }​)
    }​);
  }​

  CreateNewPrePostShipment(){
    
    //window.open('/fecr/prepostshipment/' + this.implementId, '_blank');

    this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
      if(res=="True"){
        this._router.navigate(['/fecr/prepostshipment', this.implementId]);
      }else{             
        window.open('/fecr/prepostshipment/' + this.implementId, '_blank');
       
      }
  });
  }

  OpenAdvcancedCopyPage(){
  //  window.open('/copy/implement/advance/'+ this.implementId, '_blank');

  this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
    if(res=="True"){
      this._router.navigate(['/copy/implement/advance', this.implementId]);
    }else{             
      window.open('/copy/implement/advance/'+ this.implementId, '_blank');
     
    }
});

  }

  OpenModifyImp(){
   // window.open('/setup/existing-implement-new/'+ this.implementId, '_blank');

   this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
    if(res=="True"){
      this._router.navigate(['/setup/existing-implement-new', this.implementId]);
    }else{             
      window.open('/setup/existing-implement-new/'+ this.implementId, '_blank');
     
    }
});

  }

  EnablePreference:EnablePreferenceTasksVM
  GetPreferenceTaskList(){
      this._pref.getPreferenceTaskListForLoggedUser().subscribe(res=>{
      this.EnablePreference=res
      })
  }
}
